import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_17: FaireProductEntity = {
  token: "viverano-17",
  type: "product",
  name: "Women's Organic Hooded Bath & Spa Robe, Swim Cover-Up",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/c54d23225fa99e1a808f0330e8f962af2b39539c16ebd3df0326020c488e92bc.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1400,1398,x87,y0,safe&width=720",
  priceDollars: 46,
  msrpDollars: 78,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-women"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
